import api from '@/lib/api';
import type { RetailPosSettings } from '@pms/shared';

// ─── Payload types ──────────────────────────────────────────────────────────────

/** Partial PUT — the caller read-modify-merges the cached row + the tab's fields so
 *  the single settings row is never partially blanked. `propertyId` is required. */
export type UpsertPosSettingsPayload = Partial<RetailPosSettings> & {
  propertyId: string;
};

// ─── API functions ────────────────────────────────────────────────────────────

/** Per-property POS/App-Config settings (single row). */
export async function fetchPosConfig(propertyId: string): Promise<RetailPosSettings> {
  const { data } = await api.get<RetailPosSettings>('/retail/pos-settings', {
    params: { propertyId },
  });
  return data;
}

/** PUT the merged settings object (partial merge, idempotent upsert). */
export async function upsertPosConfig(
  payload: UpsertPosSettingsPayload,
): Promise<RetailPosSettings> {
  const { data } = await api.put<RetailPosSettings>('/retail/pos-settings', payload);
  return data;
}
